// extracted by mini-css-extract-plugin
export default {"body":"eJsLEO6nZUi1uRj3xiX9","creditCard":"Wy0DRn3aDnyoj6s0yw7l","management":"Jb9ihOvCK93SuH6Anjlt","managementMobile":"tm_r9go4QbDnlI1_qtPg"};